import React from "react";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";

import { Icon, IconBox } from "@proda-ai/ui-kit";

export const testIds = {
    backButton: "TopBarOverview-backButton",
    title: "TopBarOverview-title",
    actionsContainer: "TopBarOverview-actionsContainer",
};

export type TopBarOverviewProps = BoxProps & {
    title?: React.ReactNode;
    backButtonLabel: string;
    rightContent?: React.ReactNode;
    onBackButtonClick: () => void;
};

const TopBarOverview: React.FC<TopBarOverviewProps> = props => {
    const {
        backButtonLabel,
        rightContent,
        title,
        sx,
        onBackButtonClick,
        ...otherProps
    } = props;

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "20px 24px 0 24px",
                ...sx,
            }}
            {...otherProps}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            cursor: "pointer",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "20px",
                            width: "fit-content",
                        }}
                        onClick={onBackButtonClick}
                        data-testid={testIds.backButton}
                    >
                        {" "}
                        <IconBox>
                            <Icon icon="chevron-left" size="xs" />
                        </IconBox>
                        <Typography variant="body2">
                            {backButtonLabel}
                        </Typography>
                    </Box>
                    <Typography
                        variant="h1"
                        sx={{
                            paddingBottom: "16px",
                            minHeight: "42px",
                            display: "block",
                        }}
                        data-testid={testIds.title}
                    >
                        {title}
                    </Typography>
                </Box>
                {rightContent !== undefined && (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {rightContent}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default TopBarOverview;
